import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs';

export interface GateOverridesType {
	[key: string]: boolean;
}

function parseParamGate(gate: string): [string, string | boolean] {
	const [rawGateName, rawGateValue] = gate.split(':');

	// Set default gate value to true
	let gateValue: boolean | string = rawGateValue ?? 'true';

	// Convert string values to real boolean values.
	if (gateValue.toLowerCase() === 'true') {
		gateValue = true;
	} else if (gateValue.toLowerCase() === 'false') {
		gateValue = false;
	}

	return [rawGateName, gateValue];
}

/*
 * Initialize overriding of feature gates based on query parameters from the URL
 * Multiple fg can be specified with ?fg=<name>:<value>,<other name>:<other value>, e.g.
 * ?fg=confluence_frontend_enable_feature:true,confluence_frontend_enable_other_feature:false
 * For convenience, the value may be omitted (defaults to true):
 * ?fg=confluence_frontend_enable_feature is equivalent to ?fg=confluence_frontend_enable_feature:true
 * Note: We only return the overrides here (rather than all of the feature gates)
 */
export const processQueryParamFeatureGates = (): GateOverridesType | null => {
	let search;
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const { uri } = getSSRRenderInputs();
		search = (uri || '').split('?')[1] ?? '';
	} else {
		search = window.location.search;
	}

	const queryParams = new URLSearchParams(search);
	if (!queryParams?.get || !queryParams.get('fg')) {
		return null;
	}

	const paramGates = (queryParams.get('fg') || '').split(',');
	const urlOverrides: GateOverridesType = {};
	let hasOverrides = false;
	paramGates.forEach((gate: string) => {
		const [gateName, gateValue] = parseParamGate(gate);

		// filter out feature gates with non-boolean values
		if (typeof gateValue === 'boolean') {
			urlOverrides[gateName] = gateValue;
			hasOverrides = true;
		}
	});
	return hasOverrides ? urlOverrides : null;
};
